<template>
  <div class="FullCalendarClass">
    <div class="fc-toolbar">
      <div class="fc-left">
        <el-button-group>
          <el-button
            :class="{ activeClass: calendarType == 'today' }"
            class="btnClass"
            @click="today"
            size="mini"
          >
            今日
          </el-button>
          <el-button
            :class="{ activeClass: calendarType == 'week' }"
            class="btnClass"
            @click="week"
            size="mini"
          >
            本周
          </el-button>
          <el-button
            :class="{ activeClass: calendarType == 'Month' }"
            class="btnClass"
            @click="month"
            size="mini"
          >
            本月
          </el-button>
        </el-button-group>
      </div>
      <div class="fc-center">
        <span @click="prev" style="margin-top: 2px;cursor: pointer;">
          <span v-if="activeIcon == 'left'">
            <svg
              t="1711506695633"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4420"
              width="20"
              height="20"
            >
              <path
                d="M512 51.2c256 0 467.2 211.2 467.2 467.2S768 979.2 512 979.2 51.2 768 51.2 512 256 51.2 512 51.2M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z"
                fill="#c6e2ff"
                p-id="4421"
              ></path>
              <path
                d="M588.8 633.6L435.2 492.8l166.4-153.6s6.4-6.4 6.4-19.2c0-12.8-12.8-19.2-19.2-19.2-6.4 0-12.8 6.4-12.8 6.4l-19.2 19.2L390.4 480c-6.4 0-6.4 6.4-6.4 12.8s0 12.8 6.4 19.2l160 147.2 25.6 19.2c6.4 6.4 6.4 6.4 12.8 6.4 12.8 0 19.2-12.8 19.2-19.2 0-6.4-6.4-12.8-6.4-19.2l-12.8-12.8z"
                fill="#409EFF"
                p-id="4422"
              ></path>
            </svg>
          </span>
          <span v-if="activeIcon == ''">
            <svg
              t="1711506695633"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4420"
              width="20"
              height="20"
            >
              <path
                d="M512 51.2c256 0 467.2 211.2 467.2 467.2S768 979.2 512 979.2 51.2 768 51.2 512 256 51.2 512 51.2M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z"
                fill="#bfbfbf"
                p-id="4421"
              ></path>
              <path
                d="M588.8 633.6L435.2 492.8l166.4-153.6s6.4-6.4 6.4-19.2c0-12.8-12.8-19.2-19.2-19.2-6.4 0-12.8 6.4-12.8 6.4l-19.2 19.2L390.4 480c-6.4 0-6.4 6.4-6.4 12.8s0 12.8 6.4 19.2l160 147.2 25.6 19.2c6.4 6.4 6.4 6.4 12.8 6.4 12.8 0 19.2-12.8 19.2-19.2 0-6.4-6.4-12.8-6.4-19.2l-12.8-12.8z"
                fill="#bfbfbf"
                p-id="4422"
              ></path>
            </svg>
          </span>
        </span>
        <p class="title">
          {{ title }}
        </p>
        <span @click="next" style="margin-top: 2px;cursor: pointer;">
          <span v-if="activeIcon1 == 'right'">
            <svg
              t="1711506799553"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6442"
              width="20"
              height="20"
            >
              <path
                d="M512 51.2C256 51.2 44.8 262.4 44.8 518.4S256 979.2 512 979.2 972.8 768 972.8 512 768 51.2 512 51.2zM512 0c281.6 0 512 230.4 512 512s-230.4 512-512 512-512-230.4-512-512 230.4-512 512-512z"
                fill="#c6e2ff"
                p-id="6443"
              ></path>
              <path
                d="M435.2 633.6l153.6-140.8-166.4-153.6s-6.4-6.4-6.4-19.2c0-12.8 12.8-19.2 19.2-19.2 6.4 0 12.8 6.4 12.8 6.4l19.2 19.2 166.4 153.6c6.4 0 6.4 6.4 6.4 12.8s0 12.8-6.4 19.2l-160 147.2-25.6 19.2c-6.4 6.4-6.4 6.4-12.8 6.4-12.8 0-19.2-12.8-19.2-19.2 0-6.4 6.4-12.8 6.4-19.2l12.8-12.8z"
                fill="#409EFF"
                p-id="6444"
              ></path>
            </svg>
          </span>
          <span v-if="activeIcon1 == ''">
            <svg
              t="1711506799553"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6442"
              width="20"
              height="20"
            >
              <path
                d="M512 51.2C256 51.2 44.8 262.4 44.8 518.4S256 979.2 512 979.2 972.8 768 972.8 512 768 51.2 512 51.2zM512 0c281.6 0 512 230.4 512 512s-230.4 512-512 512-512-230.4-512-512 230.4-512 512-512z"
                fill="#bfbfbf"
                p-id="6443"
              ></path>
              <path
                d="M435.2 633.6l153.6-140.8-166.4-153.6s-6.4-6.4-6.4-19.2c0-12.8 12.8-19.2 19.2-19.2 6.4 0 12.8 6.4 12.8 6.4l19.2 19.2 166.4 153.6c6.4 0 6.4 6.4 6.4 12.8s0 12.8-6.4 19.2l-160 147.2-25.6 19.2c-6.4 6.4-6.4 6.4-12.8 6.4-12.8 0-19.2-12.8-19.2-19.2 0-6.4 6.4-12.8 6.4-19.2l12.8-12.8z"
                fill="#bfbfbf"
                p-id="6444"
              ></path>
            </svg>
          </span>
        </span>
      </div>
    </div>
    <div style="padding: 40px 15px;">
      <FullCalendar
        id="calendar"
        ref="fullCalendar"
        class="demo-app-calendar"
        :options="calendarOptions"
      >
        <template v-slot:eventContent="arg">
          <!-- <el-popover placement="top-start" title="标题" width="200" :visible-arrow="false" trigger="click">
                        <div slot="reference" class="popper-content" style="color: #333;">
                            <span>{{ arg.event.extendedProps.lessionTitle }}</span>
                        </div>
                    </el-popover> -->
          <el-popover placement="bottom" width="400" trigger="click">
            <div style="box-sizing: border-box;">
              <div style="background-color: #224CDA;padding: 18px 24px;">
                <div style="color: #FFFFFF;font-size: 16px;font-weight: 600;">
                  {{ arg.event.extendedProps.lessionTitle }}
                </div>
                <div
                  style="margin-top: 7px;color: #FFFFFF;font-size: 14px;font-weight: 400;"
                >
                  {{
                    arg.event.extendedProps.start_class_date.substring(0, 11)
                  }}
                  <span>{{
                    arg.event.extendedProps.start_class_date.substring(11, 16)
                  }}</span>
                  -
                  <span>{{
                    arg.event.extendedProps.end_class_date.substring(11, 16)
                  }}</span>
                </div>
              </div>
              <div style="padding: 18px 24px;">
                <div style="color: #323233;font-weight: 400;font-size: 14px;">
                  <div>授课班级：{{ arg.event.classNames.join(' ') }}</div>
                  <div style="margin-top:20px">
                    授课课程：{{ arg.event.extendedProps.lessionTitle }}
                  </div>
                  <div style="margin-top:20px">
                    上课老师：{{ arg.event.extendedProps.lecturerName }}
                  </div>
                  <div style="margin-top:20px">
                    实到/应到：{{ arg.event.extendedProps.stuSignNum }} /
                    {{ arg.event.extendedProps.stuTotalSignNum }}
                  </div>
                </div>
              </div>
              <div style="overflow:hidden;padding:18px 24px">
                <div style="float:right">
                  <el-button
                    v-if="arg.event.extendedProps.sign_date == null"
                    type="primary"
                    size="mini"
                    @click="goTeachlessons(arg.event, arg.event.extendedProps)"
                    >去上课</el-button
                  >

                  <el-button
                    v-else
                    type="info"
                    size="mini"
                    @click="goTeachlessons(arg.event, arg.event.extendedProps)"
                    >已签到</el-button
                  >
                </div>
              </div>
            </div>
            <div slot="reference" class="popper-content" style="height: 100%;">
              <div v-if="calendarType == 'today'" style="height: 100%;">
                <div style="overflow: hidden;height: 100%;">
                  <div
                    :style="{
                      background:
                        arg.event.extendedProps.sign_date == null
                          ? arg.event.extendedProps.colorTxt
                          : 'grey',
                    }"
                    style="width: 2px;height: 100%;float: left; margin-right: 5px;"
                  ></div>
                  <div
                    :style="{
                      color:
                        arg.event.extendedProps.sign_date == null
                          ? arg.event.extendedProps.colorTxt
                          : 'grey',
                    }"
                    style="float: left;"
                  >
                    <div>{{ arg.event.extendedProps.lessionTitle }}</div>
                    <div>
                      {{
                        arg.event.extendedProps.start_class_date.substring(
                          11,
                          16
                        )
                      }}
                      -
                      {{
                        arg.event.extendedProps.end_class_date.substring(11, 16)
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- week -->

              <div v-if="calendarType == 'week'" style="height: 100%;">
                <div
                  :style="{
                    background:
                      arg.event.extendedProps.sign_date == null
                        ? arg.event.extendedProps.colorTxt
                        : 'grey',
                  }"
                  style="width: 100%;height: 2px; "
                ></div>
                <div
                  :style="{
                    color:
                      arg.event.extendedProps.sign_date == null
                        ? arg.event.extendedProps.colorTxt
                        : 'grey',
                  }"
                >
                  <div>{{ arg.event.extendedProps.lessionTitle }}</div>
                  <div>
                    {{
                      arg.event.extendedProps.start_class_date.substring(11, 16)
                    }}
                    -
                    {{
                      arg.event.extendedProps.end_class_date.substring(11, 16)
                    }}
                  </div>
                </div>
              </div>
              <div v-if="calendarType == 'Month'">
                <div
                  :style="{
                    background:
                      arg.event.extendedProps.sign_date == null
                        ? arg.event.extendedProps.colorTxt
                        : 'grey',
                  }"
                  style="width: 100%;height: 2px; "
                ></div>
                <div
                  style="width: 100%;"
                  :style="{
                    color:
                      arg.event.extendedProps.sign_date == null
                        ? arg.event.extendedProps.colorTxt
                        : 'grey',
                  }"
                >
                  <div
                    style="width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                  >
                    <span>{{
                      arg.event.extendedProps.start_class_date.substring(11, 16)
                    }}</span>
                    <span style="margin-left: 5px;">{{
                      arg.event.extendedProps.lessionTitle
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-popover>

          <!-- <el-popover placement="top-start" title="标题" width="200" :visible-arrow="false" trigger="click">
                        <i class="title">{{ arg.event.lessionTitle }}</i>
                        <el-button @click="more(arg.event)" size="mini"> 更多1 </el-button>
                        <div slot="reference" class="popper-content" style="color: #333;">
                            <span>{{ arg.timeText }}</span>
                            <i>{{ arg.event.lessionTitle }}</i>
                        </div>
                    </el-popover> -->
        </template>
        <!-- <template v-slot:dayCellContent="arg">
                    {{ arg.dayNumberText }}
                </template>
                <template v-slot:resourceLabelContent="arg">
                    {{ arg.resource.id }}
                </template> -->
      </FullCalendar>
    </div>
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
import { tchGetTeachingPlanList } from '@/api/educational.js'
import moment from 'moment'

let clickCount = 0
let prev = '' // 上一次点击的dom节点
export default {
  props: {
    timeNow: {
      type: String,
      default: '',
    },
  },
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data() {
    return {
      activeIcon: '',
      activeIcon1: '',
      // calendarType: 'Month',
      calendarType: 'week',
      // showFullcalendar: true,
      title: '',
      currentView: {},

      type: 'dategrid',
      calendarOptions: {
        firstDay: 1,
        locale: 'zh',
        timeZone: 'UTC',
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          listPlugin,
          // resourceTimelinePlugin,
          interactionPlugin,
        ],
        buttonText: {
          // 设置按钮
          today: '日',
          month: '月',
          week: '周',
          dayGrid: '天',
        },
        // initialView: "dayGridMonth", // 设置默认显示月，可选周、日
        initialView: 'customGridWeek', // 设置默认显示月，可选周、日
        // resourceAreaWidth: 200,
        // contentHeight: 500,
        // slotMinWidth: 70,
        resourceOrder: 'number',
        editable: true,
        dayMaxEvents: true, // allow "more" link when too many events
        eventDurationEditable: true, // 可以调整事件的时间
        selectable: true, // 日历格子可选择
        nowIndicator: false, // 现在的时间线显示
        aspectRatio: '1', // 设置日历的宽高比率
        moreLinkContent: '更多',
        moreLinkClassNames: 'more-btns',
        eventDisplay: 'block', // 争对全天的情况下，以块状显示
        headerToolbar: false, // 隐藏头部的导航栏
        selectMirror: false,
        displayEventEnd: true, // like 08:00 - 13:00
        eventTimeFormat: {
          // like '14:30:00'
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false,
          hour12: false, // 设置时间为24小时
        },
        events: [],
        eventColor: '#378006',
        // allDayText: "全天",
        allDaySlot: false, //是否显示日历上方的allDay
        slotMinTime: '06:00',
        slotMaxTime: '22:00',
        slotDuration: '00:15:00',
        dateClick: this.handleDateClick, //点击日程事件
        eventClick: this.handleEventClick, //点击日历中的某一日程
        select: this.handleDateSelect, // 监听用户选择的时间段，
        // eventDrop: this.handleEventDrop,  //监听事件被拖动的操作
        eventResize: this.handleEventResize, //监听事件调整大小的操作
        datesSet: this.datesSet, //日期渲染；修改日期范围后触发 点击头部按钮

        resourceAreaHeaderContent: 'Rooms',
        resources: [],
        schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
        // resourceLabelContent(arg) {
        //     return {
        //         html: `<div>id: ${arg.resource.id}</div><div>lessionTitle: ${arg.resource.lessionTitle}</div>`,
        //     };
        // },
        views: {
          customTimeLineWeek: {
            type: 'resourceTimeline',
            duration: { weeks: 1 },
            slotDuration: { days: 1 },
            buttonText: 'Custom Week',
            slotLabelFormat: {
              weekday: 'long',
              // month: 'numeric',
              // day: 'numeric',
              omitCommas: true,
            },
          },
          customTimeLineMonth: {
            type: 'resourceTimeline',
            duration: { month: 1 },
            slotLabelFormat: {
              // month: 'numeric',
              day: 'numeric',
              // omitCommas: true,
            },
          },
          customGridWeek: {
            type: 'timeGridWeek',
            dayHeaderFormat: {
              weekday: 'long',
            },
            slotLabelFormat: {
              // 左侧时间格式
              hour: '2-digit',
              minute: '2-digit',
              meridiem: 'lowercase',
              hour12: false, // false设置时间为24小时
            },
          },

          timeGridDay: {
            type: 'timeGridDay',
            dayHeaderFormat: {
              weekday: 'long',
            },
            slotLabelFormat: {
              // 左侧时间格式
              hour: '2-digit',
              minute: '2-digit',
              meridiem: 'lowercase',
              hour12: false, // false设置时间为24小时
            },
          },
        },
      },
      calendarApi: null,
      //月
      monthEvent: [],
      //周 日 列表
      weekEvent: [],
      dayDate: '',
      form: {
        content: '',
      },
      selectInfo: {},
      timeNow1: '',
      satrtTime: '',
      endTime: '',
      start_date: '',
      end_date: '',
      start_date1: '',
      start_date2: '',
      end_date2: '',

      month_start: '',
      month_end: '',
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.timeNow1 = this.timeNow
    })
  },
  watch: {
    // 切换视图显示不同的事件
    'calendarApi.view.type'(newVal) {
      console.log('当前视图模式')
      console.log(newVal)
      //this.getDtata();
    },
    timeNow(newVal) {
      console.log(newVal, 7894565461111444)
      console.log(
        moment(newVal)
          .startOf('isoWeek')
          .format('YYYY-MM-DD'),
        7894565461111444
      )
      console.log(
        moment(newVal)
          .endOf('isoWeek')
          .format('YYYY-MM-DD'),
        7894565461111444
      )
      this.$nextTick(() => {
        this.calendarOptions.events = []
        this.timeNow1 = newVal
        this.$refs.fullCalendar.getApi().gotoDate(newVal)
        this.calendarApi = this.$refs.fullCalendar.getApi()
        console.log(
          moment(this.$refs.fullCalendar.getApi().view.currentStart).format(
            'YYYY-MM-DD'
          ),
          7894656
        )
        this.title = this.calendarApi.view.title
        //this.getDtata();
        this.tchGetTeachingPlanList()
        this.activeIcon = ''
        this.activeIcon1 = ''
      })
    },
  },
  methods: {
    //去上课
    goTeachlessons(item1, item) {
      console.log('去上课')
      console.log(item, 78965265236)
      let itemArr = {}

      itemArr = {
        ...item,
        id: item1.id,
        className: item1.classNames.join(''),
      }
      console.log(itemArr, 78965265236)

      sessionStorage.setItem('subject_id', itemArr.subject_id)
      sessionStorage.setItem('Classroom', JSON.stringify(itemArr))

      this.$router.push({
        name: 'teachLessons',
        query: {
          curriculumMaterial_id: itemArr.curriculum_meterial_id,
          backname: 'classroomDetails',
          classid: itemArr.curriculum_class_id,
          teaching_plan_id: itemArr.id,
          eduCampusId: itemArr.educational_institution_campus_id,
        },
      })
    },

    tchGetTeachingPlanList() {
      if (this.calendarType == 'Month') {
        console.log('点击了月筛选')

        this.start_date = moment(
          this.$refs.fullCalendar.getApi().view.currentStart
        ).format('YYYY-MM-DD')
        this.end_date = moment(
          this.$refs.fullCalendar.getApi().view.currentStart
        )
          .endOf('month')
          .format('YYYY-MM-DD')
        tchGetTeachingPlanList({
          page_no: 1,
          page_size: 100,
          start_date: this.start_date,
          end_date: this.end_date,
        }).then((res) => {
          console.log(res, 786456131)
          res.teachingPlan.map((item) => {
            item.colorTxt = item.subjectFontColor
            item.color = item.subjectColor + '80'
            item.start = item.start_class_date
            item.end = item.end_class_date
            this.calendarOptions.events.push(item)
          })
          this.monthEvent = res.teachingPlan
          console.log(this.monthEvent, 786456131)
        })
      } else if (this.calendarType == 'week' || this.calendarType == 'today') {
        console.log(
          this.$refs.fullCalendar.getApi().view.currentStart,
          78946546
        )
        this.start_date = moment(
          this.$refs.fullCalendar.getApi().view.currentStart
        ).format('YYYY-MM-DD')
        console.log(this.start_date, 78946546)

        this.end_date = moment(
          this.$refs.fullCalendar.getApi().view.currentStart
        )
          .endOf('month')
          .format('YYYY-MM-DD')
        tchGetTeachingPlanList({
          page_no: 1,
          page_size: 100,
          start_date: this.start_date,
          end_date: this.end_date,
        }).then((res) => {
          console.log(res, 786456131)
          res.teachingPlan.map((item) => {
            item.colorTxt = item.subjectFontColor
            item.color = item.subjectColor + '80'
            item.start = item.start_class_date
            item.end = item.end_class_date
            this.calendarOptions.events.push(item)
          })
          this.weekEvent = res.teachingPlan
          console.log('周列表')
          console.log(this.weekEvent)
        })
      }
    },
    // 切换视图调用的方法
    datesSet(val) {
      this.start_date1 = moment(val.startStr).format('YYYY-MM-DD')
      console.log(val, 789465456)
      this.satrtTime = val.startStr
      this.endTime = val.endStr
    },
    // 监听用户选择的时间段，当用户选择了一段时间后会触发该回调，可以在这里处理创建新的日程。
    handleDateSelect(selectInfo) {
      console.log('selectInfo: ', selectInfo)
      this.selectInfo = selectInfo
      this.form.content = ''
      // 用户选择了一个日期范围时触发
      this.dialogFormVisible = true
    },
    // 用户拖动移动事件时触发
    // handleEventDrop(dropInfo) {
    //     console.log('dropInfo: ', dropInfo);
    //     const updatedEvent = { ...dropInfo.event };
    //     updatedEvent.start = dropInfo.revertDuration ? dropInfo.oldEvent.start : dropInfo.event.start;
    //     updatedEvent.end = dropInfo.event.end;

    //     // 更新服务器上的事件或者重新排序你的事件数组
    //     // 示例：this.updateEventOnServer(updatedEvent);

    //     // 如果是在内存中维护事件，则更新本地数据
    //     const index = this.events.findIndex(e => e.id === updatedEvent.id);
    //     if (index !== -1) {
    //         this.events.splice(index, 1, updatedEvent);
    //     }
    // },
    // 用户调整事件长度时触发
    handleEventResize(resizeInfo) {
      console.log('resizeInfo: ', resizeInfo)
      const updatedEvent = { ...resizeInfo.event }
      updatedEvent.end = resizeInfo.event.end

      // 同样更新服务器或本地数据
      // 示例：this.updateEventOnServer(updatedEvent);

      const index = this.events.findIndex((e) => e.id === updatedEvent.id)
      if (index !== -1) {
        this.events.splice(index, 1, updatedEvent)
      }
    },
    getDtata() {
      setTimeout(() => {
        this.calendarOptions.events =
          this.calendarApi.view.type === 'dayGridMonth'
            ? this.monthEvent
            : this.weekEvent
      }, 2000)
    },

    // 点击更多
    more(e) {
      console.log('more ', e)
    },
    //点击日历中的某一日程
    handleEventClick(clickInfo) {
      console.log('clickInfo:', clickInfo)
      // 用户点击事件时触发，用于编辑或删除事件
      const event = clickInfo.event
      console.log('Clicked on:', event.title)
      // 这里可以弹出模态框进行编辑或调用删除函数等操作
    },
    // 单击事件(日历中的某一天)
    handleDateClick(e) {
      this.dayDate = e.dateStr
      if (e.dateStr !== prev) {
        clickCount = 0
      }
      clickCount += 1
      prev = e.dateStr
      setTimeout(() => {
        if (clickCount === 2) {
          console.log('db click')
        } else if (clickCount === 1) {
          console.log('one click')
        }
        clickCount = 0
      }, 300)
    },
    // 切换
    prev() {
      this.activeIcon = 'left'
      this.activeIcon1 = ''

      this.calendarApi.prev()
      console.log(this.calendarApi, 784555)
      this.title = this.calendarApi.view.title
      this.calendarOptions.events = []
      this.tchGetTeachingPlanList()

      if (this.calendarType == 'Month') {
        this.$emit('prevBtn', this.calendarType)
      } else if (this.calendarType == 'week') {
        this.$emit('prevBtn', this.calendarType)
        this.$emit('weekTime', this.satrtTime)
        this.$emit('endTime', this.endTime)
      } else if (this.calendarType == 'today') {
        this.$emit('prevBtn', this.calendarType)
        this.$emit('weekTime', this.satrtTime)
      }
    },
    next() {
      this.activeIcon1 = 'right'
      this.activeIcon = ''

      this.calendarApi.next()
      console.log(this.calendarApi, 784545646)
      this.title = this.calendarApi.view.title
      this.calendarOptions.events = []
      this.tchGetTeachingPlanList()

      if (this.calendarType == 'Month') {
        this.$emit('nextBtn', this.calendarType)
      } else if (this.calendarType == 'week') {
        this.$emit('nextBtn', this.calendarType)
        this.$emit('weekTime', this.satrtTime)
        this.$emit('endTime', this.endTime)
      } else if (this.calendarType == 'today') {
        this.$emit('nextBtn', this.calendarType)
        this.$emit('weekTime', this.satrtTime)
      }
    },
    // 日
    tchGetTeachingPlanList1() {
      tchGetTeachingPlanList({
        page_no: 1,
        page_size: 100,
        start_date: this.start_date2 + ' 00:00:00',
        end_date: this.end_date2 + ' 23:59:59',
      }).then((res) => {
        console.log(res, 786456131)
        res.teachingPlan.map((item) => {
          item.colorTxt = item.subjectFontColor
          item.color = item.subjectColor + '80'
          item.start = item.start_class_date
          item.end = item.end_class_date
          this.calendarOptions.events.push(item)
        })
        this.weekEvent = res.teachingPlan
        console.log(this.monthEvent, 786456131)
      })
    },

    today(date, jsEvent, view) {
      this.activeIcon1 = ''
      this.activeIcon = ''
      this.calendarType = 'today'
      this.$emit('changeBtn', this.calendarType)
      console.log(date, 78946456)
      console.log(jsEvent, 78946456)
      console.log(view, 78946456)
      console.log(this.type, 78946456)
      console.log(this.calendarApi.view, 78946456)
      this.calendarApi.changeView('timeGridDay')
      this.calendarApi.today()
      this.title = this.calendarApi.view.title
      console.log(
        moment(this.calendarApi.view.activeStart).format('YYYY-MM-DD'),
        78946456
      )

      this.calendarOptions.events = []
      this.start_date2 = moment(this.calendarApi.view.activeStart).format(
        'YYYY-MM-DD'
      )
      this.end_date2 = moment(this.calendarApi.view.activeStart).format(
        'YYYY-MM-DD'
      )
      this.satrtTime = this.start_date2
      this.$emit('weekTime', this.satrtTime)
      console.log(this.start_date2, 78946456)
      this.tchGetTeachingPlanList1()
    },
    tchGetTeachingPlanList3() {
      tchGetTeachingPlanList({
        page_no: 1,
        page_size: 100,
        start_date: this.month_start,
        end_date: this.month_end,
      }).then((res) => {
        console.log(res, 786456131)
        res.teachingPlan.map((item) => {
          item.colorTxt = item.subjectFontColor
          item.color = item.subjectColor + '80'
          item.start = item.start_class_date
          item.end = item.end_class_date
          this.calendarOptions.events.push(item)
        })
        this.weekEvent = res.teachingPlan
        console.log(this.monthEvent, 786456131)
      })
    },
    // 月
    month() {
      console.log('点击了本月')

      this.activeIcon1 = ''
      this.activeIcon = ''
      this.calendarType = 'Month'
      this.$emit('changeBtn', this.calendarType)

      if (this.type === 'timeline') {
        this.calendarApi.changeView('customTimeLineMonth')
      } else {
        this.calendarApi.changeView('dayGridMonth')
      }
      this.calendarApi.today()
      this.title = this.calendarApi.view.title
      console.log(this.calendarApi.view, 78946456)

      console.log('this.calendarApi.view.activeStart')
      console.log(this.calendarApi.view.activeStart)
      console.log(this.calendarApi.today())

      this.month_start = moment()
        .startOf('month')
        .format('YYYY-MM-DD')
      this.month_end = moment()
        .endOf('month')
        .format('YYYY-MM-DD')

      this.$emit('weekTime', this.month_start)

      this.calendarOptions.events = []
      this.tchGetTeachingPlanList3()
    },
    // 周
    tchGetTeachingPlanList2() {
      tchGetTeachingPlanList({
        page_no: 1,
        page_size: 100,
        start_date: this.start_date2 + ' 00:00:00',
        end_date: this.end_date2 + ' 00:00:00',
      }).then((res) => {
        console.log(res, 786456131)
        res.teachingPlan.map((item) => {
          item.colorTxt = item.subjectFontColor
          item.color = item.subjectColor + '80'
          item.start = item.start_class_date
          item.end = item.end_class_date
          this.calendarOptions.events.push(item)
        })
        this.weekEvent = res.teachingPlan
        console.log(this.monthEvent, 786456131)
      })
    },
    week() {
      this.activeIcon1 = ''
      this.activeIcon = ''
      this.calendarType = 'week'
      console.log(this.calendarType, 78945614352)

      this.$emit('changeBtn', this.calendarType)
      // this.calendarOptions.events = [];
      // this.tchGetTeachingPlanList()

      if (this.type === 'timeline') {
        this.calendarApi.changeView('customTimeLineWeek')
      } else {
        this.calendarApi.changeView('customGridWeek')
      }
      this.calendarApi.today()
      this.title = this.calendarApi.view.title
      console.log(this.calendarApi.view, 78946456)
      this.calendarOptions.events = []
      this.start_date2 = moment(this.calendarApi.view.activeStart).format(
        'YYYY-MM-DD'
      )
      this.end_date2 = moment(this.calendarApi.view.activeEnd).format(
        'YYYY-MM-DD'
      )
      this.satrtTime = this.start_date2
      this.endTime = this.end_date2
      this.$emit('weekTime', this.satrtTime)
      this.$emit('endTime', this.endTime)
      console.log(this.start_date2, 78946456)
      this.tchGetTeachingPlanList2()
    },
    // 天
    day() {
      this.calendarApi.today()
      this.title = this.calendarApi.view.title
    },
  },
}
</script>
<style scoped>
/deep/ .fc .fc-scrollgrid-liquid {
  height: calc(100vh - 192px);
}

.btnClass {
  padding: 7px 15px;
}

.activeClass {
  color: white;
  border-color: #409eff;
  background-color: #409eff;
  padding: 7px 15px;
}

.demo-app {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}

.demo-app-sidebar {
  width: 300px;
  line-height: 1.5;
  background: #eaf9ff;
  border-right: 1px solid #d3e2e8;
}

.demo-app-sidebar-section {
  padding: 2em;
}

.demo-app-main {
  flex-grow: 1;
  padding: 3em;
}

.fc {
  /* the calendar root */
  max-width: 1100px;
  margin: 0 auto;
}

.fc-toolbar {
  width: 100%;
  /* margin: 30px auto; */
  display: flex;
  flex: 1;
  justify-content: space-around;
  align-content: center;
  position: relative;
}

.fc-left {
  position: absolute;
  top: 0;
  right: 10px;
}

.fc-center {
  /* height: 40px; */
  display: flex;
  align-content: center;
}

.fc-center .title {
  font-size: 16px;
  padding: 0 15px;
  font-weight: 700;
  /* height: 40px; */
  /* line-height: 40px; */
}

/deep/ .fc {
  max-width: 1300px;
}
</style>
<style>
.el-popover {
  padding: 0 !important;
}
</style>
